import React, { useState } from "react";

interface UserProfileImageProps {
  userId?: string;
  name?: string;
  avatarUrl?: string;
  size?: number;
  className?: string;
}

function getInitials(name?: string): string {
  if (!name) return "?";
  return name
    .split(" ")
    .map((p) => p[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export function UserProfileImage({
  userId,
  name,
  avatarUrl,
  size = 32,
  className = "",
}: UserProfileImageProps) {
  const [imgFailed, setImgFailed] = useState(false);

  // Derive avatar URL from CDN if not explicitly provided.
  const cdnBase = "https://app.dev.duvi.uk";
  const resolvedUrl =
    avatarUrl || (userId ? `${cdnBase}/avatars/${userId}.jpg` : null);
  const showImg = resolvedUrl && !imgFailed;

  return showImg ? (
    <img
      src={resolvedUrl}
      alt={name ?? ""}
      className={`rounded-full object-cover flex-shrink-0 ${className}`}
      style={{ width: `${size}px`, height: `${size}px` }}
      onError={() => setImgFailed(true)}
    />
  ) : (
    <div
      className={`rounded-full bg-duvi-accent flex items-center justify-center text-white flex-shrink-0 ${className}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        fontSize: size <= 24 ? "var(--text-2xs)" : "var(--text-sm)",
        fontWeight: "var(--font-weight-semibold)",
      }}
    >
      {getInitials(name)}
    </div>
  );
}
